import { TOOLTIP } from './tooltip';
import { COLORS, FONT_FAMILY } from '../../../../constants/styles';

export const DEFAULTS = {
  legend: false,
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 0,
      top: 140,
      right: 0,
      bottom: 47,
    },
  },
  animation: {
    duration: 0,
  },
  tooltips: {
    mode: 'index',
    intersect: false,
    ...TOOLTIP,
  },
  hover: {
    mode: 'index',
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
          offsetGridLines: true,
        },
        ticks: {
          padding: 5,
          fontSize: 13,
          autoSkip: true,
          maxRotation: 0,
          autoSkipPadding: 20,
          fontColor: COLORS.bluePrimary,
          callback: tick => tick.toUpperCase(),
          fontFamily: FONT_FAMILY.primary,
        },
      },
    ],
    yAxes: [
      {
        position: 'right',
        gridLines: {
          drawBorder: false,
          borderDash: [2, 4],
          tickMarkLength: 25,
          color: COLORS.lightGray,
        },
        ticks: {
          padding: 25,
          stepSize: 1,
          mirror: true,
          fontSize: 12,
          labelOffset: -10,
          fontColor: COLORS.cyanBluishGray,
          fontFamily: FONT_FAMILY.primary,
        },
      },
    ],
  },
};

export const POINT_WITHOUT_HOVER = {
  radius: 0,
  hoverRadius: 0,
  pointRadius: 0,
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/options/defaults.js